import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { GIQuestion } from 'views/App/Portal/Policy/_types/giq';

export default function useGIQ(
  manualId: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexiverse/manual-giq/v1/manuals/${manualId}/questions/${id}`;
  return useQuery<GIQuestion, ServerErrorResponse>(
    ['draft_manual_giq', manualId, id],
    async () => {
      try {
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!id,
    }
  );
}
